import { CommonModule, DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { ProjectService } from '../../../../services/project.service';
import { IMilestone, IProject, ProjectSubmissionStatusEnum } from '../../../../interfaces/models/project.model';
import { TagModule } from 'primeng/tag';
import { ConfirmationService } from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DateRangeValidatorDirective } from '../../../../directives/date-range.directive';
import { DirectionService } from '../../../../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxModule } from 'primeng/checkbox';
import { FileAuditorComponent } from '../../../projects-hub-file-auditor/projects-hub-file-auditor.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ProjectFileAuditorComponent } from '../../../../../project-file-auditor/project-file-auditor.component';
import { NotificationService } from '../../../../services/notification.service';
import { authUser, NotificationTypesEnum } from '../../../../interfaces';
import { AuthService } from '../../../../services/auth.service';
import { CustomAblePipe } from '../../../../pipes/able.pipe';
import { SubstringPipe } from '../../../../pipes/substring.pipe';
import { InputNumberModule } from 'primeng/inputnumber';
import { FileUploadValidationService } from '../../../../services/file-upload-validation.service';
@Component({
  selector: 'app-milestone',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    IconFieldModule,
    InputTextModule,
    InputIconModule,
    RadioButtonModule,
    DropdownModule,
    FormsModule,
    ConfirmPopupModule,
    TooltipModule,
    CalendarModule,
    TagModule,
    InputTextareaModule,
    DateRangeValidatorDirective,
    TranslateModule,
    CheckboxModule,
    FileAuditorComponent,
    ProjectFileAuditorComponent,
    CustomAblePipe,
    SubstringPipe,
    InputNumberModule
  ],
  templateUrl: './milestone.component.html',
  styleUrl: './milestone.component.scss',
  providers: [ConfirmationService, DatePipe],
  animations: [
    trigger('toggleWidth', [
      state('closed', style({
        width: '0',
      })),
      state('open', style({
        width: 'fit-content',  // Adjust the width as per your requirement
      })),
      transition('closed <=> open', [
        animate(1000)  // Adjust the duration and easing function as needed
      ]),
    ])
  ]
})
export class MilestoneComponent implements OnInit {
  milestoneStatusValuesLocale = {
    ar: {
      "not_started": "لم تبدأ",
      "in_progress": "قيد التنفيذ",
      "on_hold": "متوقفة",
      "completed": "نفذت",
      "approved": "معتمدة",
      "pending": "قيد المراجعة",
      "rejected": "مرفوضة",
      "awaiting_upload": "في انتظار المرفقات"
    },
    en: {
      "not_started": "Not Started",
      "in_progress": "In Progress",
      "on_hold": "On Hold",
      "completed": "Completed",
      "approved": "Approved",
      "pending": "Pending",
      "rejected": "Rejected",
      "awaiting_upload": "Awaiting Upload"
    }
  };
  actions = {
    'uploadoutput': 'uploadoutput',
    'deleteOutput': 'deleteOutput'
  }
  milestoneStatusValues = this.milestoneStatusValuesLocale.ar;
  @ViewChild('MileStoneForm') MileStoneForm!: FormGroup;
  @ViewChild('extraForm') extraForm!: FormGroup;
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  outputFiles: FileList | undefined;
  filesMetaData: any[] = [];
  @Input() assessment_status!: ProjectSubmissionStatusEnum;
  @Input() strategyId!: number;
  @Input() projectId!: number;
  @Input() set milestones(value: IMilestone[]) {
    this.filteredMilestones = value;
    this._milestones = value;
  }
  _milestoneSearchTerm = ""

  get milestoneSearchTerm() {
    return this._milestoneSearchTerm;
  }

  set milestoneSearchTerm(value: string) {
    this._milestoneSearchTerm = value
    this.search();
  }
  get milestones() {
    return this._milestones;
  }
  _milestones = [] as IMilestone[];
  filteredMilestones = [] as IMilestone[];
  isMilestoneModalVisable = false
  selectedMileStone = {} as IMilestone;
  isSubmittedMileStone = false
  isUploadoutputModalVisable = false;
  outputError = false;
  milestoneOutputUploadeId = 0
  outputList = [] as any[]
  isOutPutListModal = false;
  outputDeleteListId = [] as number[];
  dir!: 'rtl' | 'ltr';
  locale!: "ar" | "en";
  assessmentSidebarVisible = false;
  isOpen = false;

  uploadedFilesCount: number = this.filesMetaData.filter(x => !x.is_deleted).length
  ogFileList!: any[];
  user = {} as authUser;

  _project!: IProject;
  @Input() set project(project: IProject) {
    this._project = project;
    this.refreshUserOptions();
  }
  get project() {
    return this._project;
  }

  userOptions: { label: string; id: number }[] = [];
  @Input() set employees(value: any[] | null | undefined) {
    this._employees = value || [];
    this.refreshUserOptions();
  }
  get employees() {
    return this._employees;
  }
  private _employees: any[] = [];
  completionStatusOptions = [
    { label: 'لم تبدأ', value: 'not_started' },
    { label: 'قيد التنفيذ', value: 'in_progress' },
    { label: 'مكتمل', value: 'completed' },
    { label: 'متوقف', value: 'on_hold' },
    { label: 'ملغي', value: 'cancelled' }
  ];

  constructor(private projectService: ProjectService,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private directionService: DirectionService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private datePipe: DatePipe,
    private fileValidation: FileUploadValidationService,
  ) {

  }
  ngOnInit(): void {
    this.authService.authBufferSub$.subscribe(user => {
      this.user = user || {} as authUser;
    })
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
      this.locale = dir == "rtl" ? "ar" : "en";
      this.setMilestoneStatusLocale();
      if (dir == 'ltr') {
        this.completionStatusOptions = [
          { label: 'Not Started', value: 'not_started' },
          { label: 'In Progress', value: 'in_progress' },
          { label: 'Completed', value: 'completed' },
          { label: 'On Hold', value: 'on_hold' },
          { label: 'Cancelled', value: 'cancelled' }
        ];
      }
    })
    
    this.refreshUserOptions();
  }

  private refreshUserOptions(): void {
    const fromEmployees = (this._employees || []).map((user: any) => ({
      label: user.name,
      id: user.id
    }));
    const fromTeam = ((this.project as any)?.team_members || []).map((member: any) => ({
      label: member.name,
      id: member.user_id || member.id
    }));
    const merged = [...fromEmployees, ...fromTeam].filter(user => user.id && user.label);
    this.userOptions = merged.filter((user, index, list) =>
      list.findIndex(item => item.id === user.id) === index
    );
  }

  iseffectsSubmitted = false;
  search() {
    if (!this.milestoneSearchTerm || !this.milestoneSearchTerm.trim()) {
      this.filteredMilestones = this.milestones;
    }
    this.filteredMilestones = this.milestones.filter(({ name }) => {
      return name.includes(this.milestoneSearchTerm)
    });
  }

  confirmMileStoneDelete(event: Event, mileStoneId: number) {
    const target = event.target as HTMLElement;
    this.confirmationService.confirm({
      target: target,
      message: this.dir == 'rtl' ? "هل تريد تأكيد المسح؟" : "Do you want to confirm the deletion?",
      accept: () => {
        this.projectService.deleteMilestones(this.strategyId, this.projectId, mileStoneId).subscribe(() => {
          this.toastr.success(this.dir == 'rtl' ? "تم المسح " : "Delete Successfully");
          this.milestones = [...this.milestones.filter(x => x.id != mileStoneId)];
        })

      },
      reject: () => {
        this.toastr.info(this.dir == 'rtl' ? "تم الالغاء" : "Canceled");
      }
    });
  }

  accept() {
    this.confirmPopup.accept();
  }

  reject() {
    this.confirmPopup.reject();
  }

  openUpdatMileStoneModal(id: number, parent_milestone_id: number | null) {
    if (parent_milestone_id) {
      const parentMilestone = this.milestones.find(x => {
        return x.id == parent_milestone_id
      }) as IMilestone;
      const childMileStone = parentMilestone.subMilestones.find(x => x.id == id) as IMilestone;
      this.selectedMileStone = { 
        ...childMileStone, 
        start_date: this.datePipe.transform(new Date(childMileStone.start_date), 'MM/dd/yyyy')?.toString(), 
        end_date: this.datePipe.transform(new Date(childMileStone.end_date), 'MM/dd/yyyy')?.toString(),
        actual_completion_date: childMileStone.actual_completion_date ? this.datePipe.transform(new Date(childMileStone.actual_completion_date), 'MM/dd/yyyy')?.toString() : null,
        execution_responsibility: childMileStone.execution_responsibility || null,
        estimated_cost: childMileStone.estimated_cost || null,
        completion_percentage: childMileStone.completion_percentage || null,
        completion_status: childMileStone.completion_status || null
      } as IMilestone;


      this.isMilestoneModalVisable = true;
    } else {
      const milestone = this.milestones.find(x => {
        return x.id == id
      })
      this.selectedMileStone = { 
        ...milestone, 
        start_date: new Date(milestone?.start_date || ''), 
        end_date: new Date(milestone?.end_date || ''),
        actual_completion_date: milestone?.actual_completion_date ? new Date(milestone.actual_completion_date) : null,
        execution_responsibility: milestone?.execution_responsibility || null,
        estimated_cost: milestone?.estimated_cost || null,
        completion_percentage: milestone?.completion_percentage || null,
        completion_status: milestone?.completion_status || null
      } as IMilestone;
      this.isMilestoneModalVisable = true;
    }
  }

  closeMileStoneModal() {
    this.isMilestoneModalVisable = false;
    this.selectedMileStone = {} as IMilestone;
  }

  submitMileStone() {
    this.isSubmittedMileStone = true;
    if (this.MileStoneForm.valid && this.selectedMileStone.id > 0) {
      const milestoneData = {
        ...this.selectedMileStone,
        start_date: this.datePipe.transform(new Date(this.selectedMileStone.start_date), 'MM/dd/yyyy')?.toString(),
        end_date: this.datePipe.transform(new Date(this.selectedMileStone.end_date), 'MM/dd/yyyy')?.toString(),
        actual_completion_date: this.selectedMileStone.actual_completion_date ? this.datePipe.transform(new Date(this.selectedMileStone.actual_completion_date), 'MM/dd/yyyy')?.toString() : null,
        execution_responsibility: this.selectedMileStone.execution_responsibility || null,
        estimated_cost: this.selectedMileStone.estimated_cost || null,
        completion_percentage: this.selectedMileStone.completion_percentage || null,
        completion_status: this.selectedMileStone.completion_status || null
      };
      this.projectService.updateMilestones(this.strategyId, this.projectId, this.selectedMileStone.id, milestoneData).subscribe((response) => {
        this.toastr.success(response['data']['message'])
        // إعادة جلب البيانات من السيرفر لضمان تحديث جميع الحقول
        this.projectService.ListMilestonesWithPatrent(this.strategyId, this.projectId).subscribe((response: any) => {
          this.milestones = response['data']['milestones'];
        })
        this.isMilestoneModalVisable = false;
        this.isSubmittedMileStone = false;
        this.MileStoneForm.reset({});
      })
    } else {
      const milestoneData = {
        ...this.selectedMileStone,
        start_date: this.datePipe.transform(new Date(this.selectedMileStone.start_date), 'MM/dd/yyyy')?.toString(),
        end_date: this.datePipe.transform(new Date(this.selectedMileStone.end_date), 'MM/dd/yyyy')?.toString(),
        actual_completion_date: this.selectedMileStone.actual_completion_date ? this.datePipe.transform(new Date(this.selectedMileStone.actual_completion_date), 'MM/dd/yyyy')?.toString() : null,
        execution_responsibility: this.selectedMileStone.execution_responsibility || null,
        estimated_cost: this.selectedMileStone.estimated_cost || null,
        completion_percentage: this.selectedMileStone.completion_percentage || null,
        completion_status: this.selectedMileStone.completion_status || null,
        parent_milestone_id: this.parentMilestoneId
      };
      this.projectService.createMilestones(this.strategyId, this.projectId, milestoneData).subscribe((response) => {
        this.toastr.success(response['data']['message'])
        // إعادة جلب البيانات من السيرفر لضمان تحديث جميع الحقول
        this.projectService.ListMilestonesWithPatrent(this.strategyId, this.projectId).subscribe((response: any) => {
          this.milestones = response['data']['milestones'];
        })
        this.isMilestoneModalVisable = false;
        this.isSubmittedMileStone = false;
        this.selectedMileStone = {} as IMilestone;
        this.parentMilestoneId = null;
        this.MileStoneForm.reset({});
      })
    }

  }

  openUploadoutputModal(milestoneId: number, parent_milestone_id: number | null) {
    if (parent_milestone_id) {
      this.milestoneOutputUploadeId = milestoneId
      const parentMilestone = this.milestones.find(x => {
        return x.id == parent_milestone_id
      }) as IMilestone;
      const childMileStone = parentMilestone.subMilestones.find(x => x.id == milestoneId) as IMilestone;
      this.selectedMileStone = { ...childMileStone, start_date: this.datePipe.transform(new Date(childMileStone.start_date), 'MM/dd/yyyy')?.toString(), end_date: this.datePipe.transform(new Date(childMileStone.end_date), 'MM/dd/yyyy')?.toString() } as IMilestone;


      this.isUploadoutputModalVisable = true
    } else {
      this.milestoneOutputUploadeId = milestoneId;
      this.selectedMileStone = this.milestones.find(x => x.id == milestoneId) as IMilestone
      this.isUploadoutputModalVisable = true
    }
    // this.milestoneOutputUploadeId = milestoneId;

    // this.selectedMileStone = this.milestones.find(x => x.id == milestoneId) as IMilestone
    // this.isUploadoutputModalVisable = true
  }

  closeUploadoutputModal() {
    this.filesMetaData = []
    this.outputFiles = undefined;
    this.milestoneOutputUploadeId = 0;
    this.isUploadConfirmed = false;
    this.isUploadoutputModalVisable = false;
    const dataTransfer = new DataTransfer();
    this.fileInput.nativeElement.files = dataTransfer.files;
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }

    const validation = this.fileValidation.validateFiles(input.files, {
      maxCount: this.selectedMileStone.left ?? FileUploadValidationService.MILESTONE_MAX_FILES
    });
    if (!validation.valid) {
      input.value = '';
      this.toastr.error(this.dir === 'rtl' ? 'نوع الملف أو الحجم غير مسموح' : 'File type or size is not allowed.');
      return;
    }

    this.outputFiles = input.files;
    this.ogFileList = Array.from(input.files);
    for (let i = 0; i < this.outputFiles.length; i++) {
      if (!this.selectedMileStone.left) {
        this.toastr.error(this.dir === 'rtl' ? 'لا يسمح برفع مزيد من المخرجات بعد استيفاء الحد الأقصى' : "Can't upload more than the limit after the maximum");
        return;
      }
      this.selectedMileStone.current = this.selectedMileStone.current + 1;
      this.selectedMileStone.left = this.selectedMileStone.left - 1;
      const { name, type, size } = this.outputFiles[i];
      const extension = this.fileValidation.getExtension(name);
      let icon = 'fa-solid fa-file';
      let color = 'gray';
      if (['.png', '.jpg', '.jpeg', '.gif', '.webp'].includes(extension)) {
        icon = 'fa-solid fa-file-image';
      } else if (['.doc', '.docx'].includes(extension)) {
        icon = 'fa-solid fa-file-word';
        color = 'blue';
      } else if (extension === '.pdf') {
        icon = 'fa-solid fa-file-pdf';
        color = 'red';
      }
      this.filesMetaData.push({ name, type, size, icon, color, is_deleted: false });
      this.uploadedFilesCount = this.filesMetaData.filter(x => !x.is_deleted).length;
    }
  }

  uploadOutput() {

    if (this.outputFiles?.length) {
      const formdata = new FormData();
      Array.from(this.outputFiles).forEach(file => {
        formdata.append("mediaFiles", file)
      })

      this.projectService.uploadOutputFileMilestone(this.strategyId, this.projectId, this.milestoneOutputUploadeId, formdata)
        .subscribe((response: any) => {

          this.toastr.success(response['data']['message']);

          this.notificationService.pushAuditRequest(
            this.strategyId, {
            id: +response["data"]["uploadedFilesIds"][0],
            parentEntityId: +this.projectId,
            subEntityId: +this.milestoneOutputUploadeId,
            type: NotificationTypesEnum.milestone_output_audit_request
          },
            this.locale
          );

          // hold
          this.getFreshStatus(this.milestoneOutputUploadeId, this.actions.uploadoutput);
        }, ({ error }) => {
          this.selectedMileStone.left = error['error'].left;
          this.getFreshStatus(this.milestoneOutputUploadeId, this.actions.uploadoutput);
        })
    } else {
      this.outputError = true;
    }
  }

  private getFreshStatus(milestoneId: number, action: string) {
    this.projectService.GetMilestoneStatus(this.strategyId, this.projectId, milestoneId).subscribe((response: any) => {
      const data = response.data;
      this.milestones = this.milestones.map(x => {
        if (x.id == milestoneId) {
          console.log("data", data);
          return { ...x, ...data };
        } else {
          return x;
        }
      });
      if (action == "uploadoutput") {
        this.closeUploadoutputModal();
      } else if (action == "deleteOutput") {
        this.closeOutputListModal()
      }
    });
  }

  deleteFile(index: number) {
    this.selectedMileStone.current = this.selectedMileStone.current - 1;
    this.selectedMileStone.left = this.selectedMileStone.left + 1;
    this.filesMetaData[index].is_deleted = true;
    this.uploadedFilesCount = this.filesMetaData.filter(x => !x.is_deleted).length;
    const dataTransfer = new DataTransfer();
    this.ogFileList = this.ogFileList.filter((file) => {
      return this.filesMetaData.filter(x => x.name == file.name && !x.is_deleted)[0]
    })
    this.ogFileList.forEach(file => dataTransfer.items.add(file as File));
    this.fileInput.nativeElement.files = dataTransfer.files;
  }

  openListOutPutModal(mileStoneId: number, parent_milestone_id: number | null) {
    if (parent_milestone_id) {
      const parentMilestone = this.milestones.find(x => {
        return x.id == parent_milestone_id
      }) as IMilestone;
      const childMileStone = parentMilestone.subMilestones.find(x => x.id == mileStoneId) as IMilestone;
      this.selectedMileStone = { ...childMileStone, start_date: this.datePipe.transform(new Date(childMileStone.start_date), 'MM/dd/yyyy')?.toString(), end_date: this.datePipe.transform(new Date(childMileStone.end_date), 'MM/dd/yyyy')?.toString() } as IMilestone;
      this.projectService.listOutputFileMilestone(this.strategyId, this.projectId, mileStoneId).subscribe((response) => {
        this.outputList = response['data']['outputs'];
        this.isOutPutListModal = true;
      })

      this.isOutPutListModal = true;
    } else {
      this.selectedMileStone = this.milestones.find(x => x.id == mileStoneId) as IMilestone
      this.projectService.listOutputFileMilestone(this.strategyId, this.projectId, mileStoneId).subscribe((response) => {
        this.outputList = response['data']['outputs'];
        this.isOutPutListModal = true;
      })
    }

  }

  closeOutputListModal() {
    this.isOutPutListModal = false;
  }

  downloadOutput(outputId: number, mileStoneId: number, file_name: string) {
    this.projectService.downloadMilestonOutput(this.strategyId, this.projectId, mileStoneId, outputId).subscribe((x) => {
      const blob = new Blob([x], { type: x.type });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = file_name;
      anchor.click();
      window.URL.revokeObjectURL(url);
    })
  }

  confirmoutputDelete(event: Event, milestone_id: number, outputId: number) {
    const target = event.target as HTMLElement;

    this.confirmationService.confirm({
      target: target,
      message: this.dir == 'rtl' ? "هل تريد تأكيد المسح؟" : "Do you want to confirm the deletion?",
      accept: () => {
        this.projectService.deleteMilestonOutput(this.strategyId, this.projectId, milestone_id, outputId).subscribe((response: any) => {
          this.outputList = this.outputList.filter((x: any) => {
            return x.id != outputId
          })
          this.getFreshStatus(milestone_id, this.actions.deleteOutput);
          this.toastr.success(this.dir == 'rtl' ? "تم المسح " : "Delete Successfully");
        }, (error) => {
          this.getFreshStatus(milestone_id, this.actions.deleteOutput);
          this.toastr.error(this.dir == 'rtl' ? "فشل المسح " : "Delete Failed");
        })
      },
      reject: () => {
        this.toastr.info(this.dir == 'rtl' ? "تم الالغاء" : "Canceled");
      }
    });

  }


  submit() {
    this.iseffectsSubmitted = true;
    
    // Fields that backend requires but we want to make optional in frontend
    const formValues = { ...this.extraForm.value };
    
    // Replace empty positive_effects with "."
    const positiveEffects = formValues['positive_effects']?.toString() || '';
    if (!positiveEffects || positiveEffects.trim() === '') {
      formValues['positive_effects'] = '.';
    }
    
    // Replace empty supporting_models_studies with "."
    const supportingModels = formValues['supporting_models_studies']?.toString() || '';
    if (!supportingModels || supportingModels.trim() === '') {
      formValues['supporting_models_studies'] = '.';
    }
    
    this.projectService.UpdateEffectsandStudies(this.strategyId, this.projectId, formValues).subscribe((response) => {
      this.toastr.success(this.dir == 'rtl' ? "نجح التحديث" : "Updated Successfully")
      this.iseffectsSubmitted = false;
    }, (error) => {
      this.toastr.error(this.dir == 'rtl' ? 'فشل التحديث' : 'Update failed')
    })
  }


  _isUploadConfirmed = false;
  set isUploadConfirmed(value: boolean) {
    console.log(value);
    this._isUploadConfirmed = value;
  }
  get isUploadConfirmed() {
    return this._isUploadConfirmed;
  }
  closeAssessmentSidebarVisible() {
    this.assessmentSidebarVisible = false;
    this.isOpen = false;
  }
  openAssessmentSidebar() {

    this.assessmentSidebarVisible = true;
    this.isOpen = true;
  }
  onFileReviewed(event: any) {
    this.projectService.ListMilestonesWithPatrent(this.strategyId, this.projectId).subscribe((response: any) => {
      console.log("onFileReviewed", response['data']['milestones']);
      this.milestones = response['data']['milestones'];
    })
  }

  setMilestoneStatusLocale() {
    this.milestoneStatusValues = this.dir == 'rtl' ? this.milestoneStatusValuesLocale.ar : this.milestoneStatusValuesLocale.en;
  };

  parentMilestoneId = null;
  selectedParentMileStone = {} as IMilestone;
  addNewMilstone(milestoneId: any) {
    this.isMilestoneModalVisable = true;
    this.parentMilestoneId = milestoneId;
    this.selectedParentMileStone = this.milestones.find(x => x.id == milestoneId) as IMilestone;
  }

  getCompletionStatusLabel(status: string | null | undefined): string {
    if (!status) return '-';
    const option = this.completionStatusOptions.find(s => s.value === status);
    return option ? option.label : status;
  }

  getExecutionResponsibilityName(responsibilityId: number | null | undefined): string {
    if (!responsibilityId) return '-';
    const user = this.userOptions.find(u => u.id === responsibilityId);
    return user ? user.label : '-';
  }

}
